<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102.28 102.28">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_4" data-name="Layer 4">
                <circle cx="51.14" cy="51.14" r="51.14" fill="#c6c6c5" />
                <polygon points="66.16 52.55 52.42 67.53 38.65 52.55 44.26 52.55 44.26 41.98 60.55 41.98 60.55 52.55 66.16 52.55" fill="#fff" />
                <g>
                    <path
                        d="M40.41,78.31l-3.09-5.62H39.6l1.3,2.58c.27.53.52,1.07.87,1.77h.07c.29-.7.53-1.24.78-1.77l1.23-2.58H46L43,78.41l3.29,5.89H44l-1.42-2.74c-.3-.59-.59-1.18-.93-1.89h-.08c-.3.71-.58,1.3-.85,1.89L39.3,84.3H37.11Z"
                        fill="#fff"
                    />
                    <path d="M49.74,72.69h2v9.88h4.82V84.3H49.74Z" fill="#fff" />
                    <path
                        d="M59.18,82.81l1.2-1.41a4.57,4.57,0,0,0,3,1.32c1.3,0,2-.59,2-1.5s-.75-1.26-1.8-1.7L62,78.83a3.34,3.34,0,0,1-2.35-3.08c0-1.85,1.64-3.27,3.9-3.27A5.08,5.08,0,0,1,67.17,74l-1.06,1.3a3.76,3.76,0,0,0-2.52-1c-1.1,0-1.82.51-1.82,1.36s.89,1.25,1.85,1.64l1.57.66a3.22,3.22,0,0,1,2.34,3.13c0,1.88-1.56,3.45-4.17,3.45A6,6,0,0,1,59.18,82.81Z"
                        fill="#fff"
                    />
                </g>
                <g>
                    <path
                        d="M24.15,27.61H27c1.77,0,3.12.62,3.12,2.51S28.77,32.77,27,32.77H25.65v3.31h-1.5Zm2.7,4c1.16,0,1.79-.48,1.79-1.45s-.63-1.31-1.79-1.31h-1.2v2.76Zm-.13.8,1.09-.9,2.64,4.61H28.77Z"
                        fill="#fff"
                    />
                    <path d="M32.46,27.61h5.1v1.27H34v2.17h3v1.26H34v2.51h3.73v1.26H32.46Z" fill="#fff" />
                    <path
                        d="M40.07,27.61h1.7l1.5,4.14c.18.54.36,1.11.54,1.66h0c.19-.55.35-1.12.54-1.66l1.46-4.14h1.7v8.47H46.19V32.21c0-.79.11-1.91.19-2.7h-.05l-.69,2-1.39,3.81h-.89L42,31.48l-.68-2h-.05c.07.79.19,1.91.19,2.7v3.87H40.07Z"
                        fill="#fff"
                    />
                    <path
                        d="M49.6,35.07l.71-1a2.7,2.7,0,0,0,1.95.9c.9,0,1.52-.47,1.52-1.24s-.54-1.4-2.42-1.4V31.29c1.62,0,2.14-.56,2.14-1.32a1.07,1.07,0,0,0-1.21-1.1,2.38,2.38,0,0,0-1.65.78l-.77-.93a3.63,3.63,0,0,1,2.48-1c1.57,0,2.66.79,2.66,2.18a2,2,0,0,1-1.44,1.9v0a2.08,2.08,0,0,1,1.72,2.05c0,1.5-1.31,2.38-2.9,2.38A3.56,3.56,0,0,1,49.6,35.07Z"
                        fill="#fff"
                    />
                    <path
                        d="M57.65,27.61h2.86c1.76,0,3.12.62,3.12,2.51s-1.36,2.65-3.12,2.65H59.16v3.31H57.65Zm2.7,4c1.16,0,1.79-.48,1.79-1.45s-.63-1.31-1.79-1.31H59.16v2.76Zm-.12.8,1.08-.9L64,36.08H62.27Z"
                        fill="#fff"
                    />
                    <path
                        d="M65.52,31.88c0-2.78,1.73-4.42,3.88-4.42a3.36,3.36,0,0,1,2.44,1.07l-.8,1a2.22,2.22,0,0,0-1.61-.74c-1.38,0-2.37,1.17-2.37,3.07s.91,3.1,2.33,3.1a2.41,2.41,0,0,0,1.81-.87L72,35a3.36,3.36,0,0,1-2.66,1.24C67.21,36.24,65.52,34.68,65.52,31.88Z"
                        fill="#fff"
                    />
                    <path d="M74.06,27.61h1.51V31H79V27.61H80.5v8.47H79V32.33H75.57v3.75H74.06Z" fill="#fff" />
                </g>
            </g>
        </g>
    </svg>
</template>
<script>
export default {};
</script>



// WEBPACK FOOTER //
// ExportXlsForImportIcon.vue?47a246b0